'use client'
import React from 'react'
import { FaShareNodes } from 'react-icons/fa6'
import { translateIt } from '@/data/translations'
import { LANGUAGE } from '@/data/constants'

export default function ShareButton(props) {
  const { title, text, url } = props

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url || window.location.href
        })
      } catch (err) {
        console.error('Error sharing:', err)
      }
    } else {
      // Fallback to copy to clipboard
      try {
        await navigator.clipboard.writeText(url || window.location.href)
        alert(translateIt(LANGUAGE, 'linkCopied'))
      } catch (err) {
        console.error('Error copying to clipboard:', err)
      }
    }
  }

  return (
    <button
      onClick={handleShare}
      className="bg-zink-100 text-white px-4 py-1 rounded-full flex items-center gap-2 hover:bg-zink-200"
    >
      <FaShareNodes /> {translateIt(LANGUAGE, 'share')}
    </button>
  )
}
